import * as React from 'react';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { IStore } from 'redux/IStore';
import { connect } from 'react-redux';
import { ITranslateProps } from 'models/common';
import { Button, GeoMap, Spinner } from 'components';
import { Link } from 'react-router';
import { AnyMapItem } from 'models/map';
import { IOfficeListItem } from 'models/shop/office';
import { PortalInputField, PortalSelectMenu } from 'components/FormControls';

interface IOwnProps {
	officeId: string;
	shopId: string;
	changeOfficeId: (officeId: string) => void;
}

interface IState {
	// hoverOver: string;
	clicked: string;
}

interface IProps extends IOwnProps, Partial<ITranslateProps>, ReturnType<typeof mapStateToProps> {}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ShopCardOfficesMapComponent extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);

		this.state = {
			// hoverOver: null,
			clicked: undefined,
		};

		this.setClicked = this.setClicked.bind(this);
		this.selectSalonClick = this.selectSalonClick.bind(this);
		// this.setHovered = this.setHovered.bind(this);
		// this.unsetHovered = this.unsetHovered.bind(this);
		this.markerClick = this.markerClick.bind(this);
	}

	private setClicked(item: IOfficeListItem) {
		if (this.state.clicked !== item.id) {
			this.setState({
				clicked: item.id,
			});
		}
	}

	// private setHovered(item: IOfficeListItem) {
	// 	if (this.state.hoverOver !== item.id) {
	// 		this.setState({
	// 			hoverOver: item.id,
	// 		});
	// 	}
	// }

	// private unsetHovered() {
	// 	if (this.state.hoverOver) {
	// 		this.setState({
	// 			hoverOver: undefined,
	// 		});
	// 	}
	// }

	private markerClick(item: IOfficeListItem) {
		this.setClicked(item);
	}

	private selectSalonClick() {
		this.props.changeOfficeId(this.state.clicked);
	}

	private renderOfficeSelect() {
		const { offices, t, officeId } = this.props;
		if (offices.length === 1) {
			return (
				<PortalInputField
					input={{ name: '', value: offices[0]?.location }}
					label={t('Shop_ManageShop_Location_Label_SalonLocation')}
					readOnly={true}
				/>
			);
		}
		return (
			<PortalSelectMenu
				usage="portal"
				input={{
					value: officeId,
					onChange: this.props.changeOfficeId,
				}}
				items={offices.map((x) => ({ key: x.id, value: x.location }))}
				label={t('Shop_ManageShop_Location_Label_SalonLocation')}
				isRequired={true}
				searchable={false}
			/>
		);
	}

	public render() {
		const { t, offices, isMyShop, shopId, shopPicture, officeId, userPreferences, name, averageRating, votes } =
			this.props;
		if (!offices) {
			return <Spinner />;
		}
		if (!offices.length) {
			if (isMyShop) {
				return (
					<Link to={'shop/' + shopId + '/edit/locations'}>
						<Button>{t('Shop_ManageShop_Location_Title')}</Button>
					</Link>
				);
			}
			return null;
		}

		const mapItems =
			this.state.clicked || officeId
				? offices.map((i): AnyMapItem => {
						if (this.state.clicked === i.id || (officeId === i.id && !this.state.clicked)) {
							return Object.assign(
								{ shop: { picture: shopPicture, name: name } },
								{
									...i,
									isHighlighted: true,
									shopAverageRating: averageRating,
									votes: votes,
									isFromShopPage: true,
								},
							);
						}
						return Object.assign(
							{ shop: { picture: shopPicture, name: name } },
							{ ...i, isFromShopPage: true, shopAverageRating: averageRating, votes: votes },
						);
				  })
				: offices;
		return (
			<>
				<h4 className="subtitle d-none d-lg-block">
					{`${t('Shop_ManageShop_Location_Label_Locations').toUpperCase()}`}
					<span className="muted">{offices.length}</span>
				</h4>
				<GeoMap
					showInfoWindow={true}
					className="xsmall inset"
					items={mapItems || []}
					mapSettings={{
						streetViewControl: false,
					}}
					// onMarkerMouseEnter={this.setHovered}
					// onMarkerMouseLeave={this.unsetHovered}
					onClick={this.markerClick}
					onSelectClick={this.selectSalonClick}
					userPicture={userPreferences.profilePicture}
				/>
				{this.renderOfficeSelect()}
			</>
		);
	}
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const mapStateToProps = (state: IStore, _ownProps: IOwnProps) => {
	const offices = state.shopcard.shopcard?.offices;
	return {
		offices,
		isMyShop: state.shopcard.isMyShop,
		shopPicture: state.shopcard.shopcard?.picture,
		userPreferences: state.userPreferences,
		name: state.shopcard.shopcard.name,
		averageRating: state.shopcard.shopcard?.averageRating,
		votes: state.shopcard.shopcard?.votes,
	};
};

const ShopCardOfficesMap = connect(mapStateToProps, () => ({}))(ShopCardOfficesMapComponent);

export { ShopCardOfficesMap };
